import React from "react";

const NutritionFoodCard = ({
  foodName,
  quantity,
  quantityType,
  scaledNutrition,
}) => {
  const scaled = scaledNutrition || {};
  const displayCalories = Number(scaled.calories ?? 0).toFixed(1);

  const getNutrient = (key) => {
    const val =
      key === "protein"
        ? scaled.proteins ?? scaled.protein
        : key === "sugar"
          ? scaled.sugars ?? scaled.sugar
          : scaled[key];
    return typeof val === "number" ? val.toFixed(1) : "0";
  };

  return (
    <div className="bg-white shadow-lg rounded-2xl p-5 w-full border border-gray-100">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h2 className="text-xl font-semibold text-gray-800">{foodName}</h2>
          <p className="text-sm text-gray-500 mt-1">
            Quantity:{" "}
            <span className="font-medium text-gray-700">
              {quantity} {quantityType}
            </span>
          </p>
        </div>
        <span className="bg-orange-50 text-orange-primary font-semibold px-3 py-1 rounded-full text-sm shadow-sm">
          {displayCalories} kcal
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-3 gap-x-6 text-sm mt-2">
        <div>
          <p className="text-gray-400">Protein</p>
          <p className="text-gray-800 font-medium">{getNutrient("protein")} g</p>
        </div>
        <div>
          <p className="text-gray-400">Carbs</p>
          <p className="text-gray-800 font-medium">{getNutrient("carbs")} g</p>
        </div>
        <div>
          <p className="text-gray-400">Fat</p>
          <p className="text-gray-800 font-medium">{getNutrient("fats")} g</p>
        </div>
        <div>
          <p className="text-gray-400">Fiber</p>
          <p className="text-gray-800 font-medium">{getNutrient("fiber")} g</p>
        </div>
        <div>
          <p className="text-gray-400">Sugar</p>
          <p className="text-gray-800 font-medium">{getNutrient("sugar")} g</p>
        </div>
      </div>
    </div>
  );
};

export default NutritionFoodCard;
